import {AuthService}  from 'hasta-la-vista-middleware-api/service'
export default {
    name: 'sign_in_banner',
    props: {
        section: Object,
    },

    data(){
        return {signUp: true,}
    },

    created(){
        AuthService.user().then((user)=> {
            if (user.isGuest) this.signUp = false;
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/content/sign_in_banner/sign_in_banner.js